export const ConfigMantenedorBhe = {
	barraBusqueda: {
		criterios: ["Nombre Receptor","Rut Receptor", "Folio"],
		criteriosKeys: ["nombreReceptor", "rutReceptor", "folio"],
		criterioPrincipal: "Nombre Receptor",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Boletas de Honorarios Emitidas",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
